function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "icon_40_"
}, /*#__PURE__*/React.createElement("path", {
  d: "m421.587 360.091-1.437 11.492-1.916 15.276-11.975 96.398h-329.261l-11.976-96.398-1.915-15.276-1.438-11.492z",
  fill: "#f6b863"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f4bb87"
}, /*#__PURE__*/React.createElement("path", {
  d: "m210.276 149.599h62.705v46.563h-62.705z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m186.019 89.487c-7.431 0-13.455 6.024-13.455 13.455v1.491c.01 7.424 6.031 13.437 13.455 13.437 2.894 0 5.239-2.346 5.239-5.239v-17.917c-.007-2.889-2.35-5.227-5.239-5.227z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.285 89.487c7.431 0 13.454 6.024 13.454 13.455v1.491c-.01 7.424-6.031 13.437-13.454 13.437-2.894 0-5.239-2.346-5.239-5.239v-17.917c.006-2.889 2.35-5.227 5.239-5.227z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m300.067 50.732v53.529c0 1.697-7.744 35.454-28.041 53.671-4.29 3.848-7.072 9.205-13.313 12.317-10.755 5.099-23.232 5.099-33.987 0-6.229-3.118-9.023-8.469-13.313-12.317-20.297-18.216-28.182-51.973-28.182-53.671v-53.529c37.105-12.606 76.189-11.474 116.836 0z",
  fill: "#fed19a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m183.284 90.347s17.68-10.402 20.798-38.059c0 0 14.144 6.86 53.547 13.054s42.485 24.782 42.485 24.782c6.564-17.428 7.008-36.57 1.261-54.284-15.983-38.042-65.64-43.074-82.012-27.805-63.065 6.73-36.079 82.312-36.079 82.312z",
  fill: "#414451"
}), /*#__PURE__*/React.createElement("path", {
  d: "m373.345 299.266c-26.673 24.811-77.498 29.131-77.498 29.131h-108.438s-50.824-4.32-77.497-29.131c-18.611-17.309 1.373-62.469 15.152-88.194 8.084-15.273 21.445-27.086 37.594-33.238 12.936-4.61 26.118-8.496 39.485-11.639.371-.077.743-.147 1.043-.224 3.206-.819 5.663-1.344 7.302-1.715 1.179 19.371 12.965 31.441 31.14 31.588 18.175-.147 29.95-12.217 31.14-31.588 1.638.371 4.125.896 7.302 1.715.301.077.672.147 1.043.224 13.367 3.14 26.55 7.022 39.485 11.628 16.139 6.156 29.49 17.966 37.57 33.233 13.803 25.735 33.788 70.901 15.177 88.21z",
  fill: "#ef5261"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280.071 165.988c-1.939 22.501-16.837 37.128-38.366 37.323-21.605-.224-36.58-14.828-38.519-37.323 3.206-.819 5.663-1.344 7.302-1.715 1.179 19.371 12.965 31.441 31.14 31.588 18.175-.147 29.95-12.217 31.14-31.588 1.639.372 4.097.896 7.303 1.715z",
  fill: "#da364c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m338.12 212.923h-192.984c-8.157-.002-14.77 6.609-14.772 14.766 0 .6.036 1.199.109 1.795l11.645 95.242c.91 7.398 7.191 12.959 14.645 12.965h169.728c7.461.002 13.752-5.56 14.663-12.965l11.645-95.248c.986-8.097-4.778-15.46-12.875-16.446-.597-.074-1.2-.11-1.804-.109z",
  fill: "#eeefee"
}), /*#__PURE__*/React.createElement("path", {
  d: "m51.874 337.709h379.508c2.646 0 4.791 2.145 4.791 4.791v24.31c0 2.646-2.145 4.791-4.791 4.791h-379.508c-2.646 0-4.791-2.145-4.791-4.791v-24.31c0-2.646 2.145-4.791 4.791-4.791z",
  fill: "#f6b863"
}), /*#__PURE__*/React.createElement("path", {
  d: "m266.416 276.158c0 8.251-11.05 14.863-24.823 14.863s-24.752-6.612-24.752-14.863 11.05-14.786 24.752-14.786 24.823 6.612 24.823 14.786z",
  fill: "#dbd8dd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m420.15 371.583-1.916 15.276h-353.212l-1.915-15.276z",
  fill: "#eaa14e"
})));

function SvgEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 483.257 483.257",
    height: 512,
    viewBox: "0 0 483.257 483.257",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.89c0cb19.svg";
export { ForwardRef as ReactComponent };